import { LayoutUnitProps, LayoutUnit } from "./LayoutUnit";

export interface LayoutFloorProps {
  units: LayoutUnitProps[];
}

export class LayoutFloor {
  constructor(public units: LayoutUnit[]) {}

  static create(props: LayoutFloorProps) {
    return new LayoutFloor(props.units.map((x) => LayoutUnit.create(x)));
  }

  get isEmpty(): boolean {
    if (!this.units || !this.units.length) return true;

    if (this.units.length === 1 && this.units[0].isUnassigned) return true;

    return false;
  }

  static empty() {
    return new LayoutFloor([new LayoutUnit()]);
  }

  popUnit() {
    if (this.units.length) return this.units.pop();
  }

  pushUnit() {
    return this.units.push(new LayoutUnit());
  }

  updateUnit(index: number, props: LayoutUnitProps) {
    this.units[index] = LayoutUnit.create(props);
  }

  get filled() {
    return !this.units.some((x) => x.isUnassigned);
  }

  public sameTo(otherProps: LayoutFloorProps) {
    if (this.units.length !== otherProps.units.length) return false;

    for (let i = 0; i < this.units.length; i++)
      if (!this.units[i].sameTo(otherProps.units[i])) return false;

    return true;
  }
}
